import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useTranslation } from 'next-i18next'
import {
  NearbySearchCountsResult,
  useNearbySearchCounts
} from 'src/components/SearchManager/hostCtaQuery'
import useWhatsappCityHint from 'src/hooks/useWhatsappCityHint'
import ga from 'src/utils/pixels/gtag'
import { appendCityHint, buildWhatsappUrl } from 'src/utils/whatsapp'

interface Props {
  locationName?: string
  nearbySearchData?: NearbySearchCountsResult
}

/** A short recovery path before the partner alternatives and directory.
 * Uses the existing search-recovery event, never listing conversion intent. */
export default function EmptySearchSummary({
  locationName,
  nearbySearchData
}: Props) {
  const { t } = useTranslation('common')
  const cityHint = useWhatsappCityHint()
  const nearbySupply = useNearbySearchCounts(nearbySearchData)

  return (
    <div className="mb-5 border-l-2 border-blue-500 pl-4">
      <p className="text-sm leading-relaxed text-ink-700">
        {t('SEARCH_MANAGER.EMPTY_RECOVERY')}
      </p>
      <a
        href={buildWhatsappUrl(
          appendCityHint(t('CAPTURE_LEAD.WHATSAPP_MSG'), cityHint)
        )}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-3 inline-flex min-h-11 items-center justify-center gap-2 rounded-full bg-blue-500 px-4 py-2 text-sm font-semibold text-white-500 transition-colors hover:bg-blue-400"
        onClick={() => {
          ga.event('search_empty_wa_click', {
            zero_results: true,
            unserved_area: nearbySupply?.total === 0,
            location_name: locationName ?? null,
            has_city_hint: !!cityHint,
            surface: 'empty_summary'
          })
        }}
      >
        <WhatsAppIcon className="text-lg" />
        {t('CAPTURE_LEAD.WHATSAPP_CTA')}
      </a>
    </div>
  )
}
